import React from 'react'
import ReactDOM from 'react-dom'
import { useSelector } from 'react-redux'
import block from 'bem-cn'
import { AnimatePresence, motion } from 'framer-motion'

import { ReactComponent as CloseImg } from 'shared/img/modal-close.svg'

import { selectLocaleDict } from 'features/locale/selectors'

import { Button } from 'components/UIKit/Button/Button'

import './Modal.scss'

interface IModalProps {
  open: boolean
  handleClose: () => void
  hideCloseBtn?: boolean
  handleSave?: () => void
  needSaveBtn?: () => boolean
  bgColor?: string
  borderRadius?: number
  noPaddings?: boolean
  isFull?: boolean
}

const b = block('modal')

const Modal: React.FC<IModalProps> = ({
  open,
  handleClose,
  children,
  hideCloseBtn = false,
  handleSave,
  needSaveBtn = false,
  bgColor,
  borderRadius,
  noPaddings = false,
  isFull = false,
}) => {
  const locale = useSelector(selectLocaleDict).common

  const onClose = () => {
    handleClose()
  }

  const contentContainerStyle: React.CSSProperties = {
    backgroundColor: bgColor,
    borderRadius,
    padding: noPaddings ? 0 : undefined,
    width: isFull ? '100%' : undefined,
    height: isFull ? '100%' : undefined,
  }

  const content = (
    <AnimatePresence exitBeforeEnter>
      {open && (
        <>
          <motion.div
            className={b()}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}>
            <div className={b('backdrop')} onClick={onClose} />
            <div className={b('content-container')} style={contentContainerStyle}>
              {needSaveBtn && (
                <div className={b('save-block')}>
                  <Button text={locale.save} onClick={handleSave} />
                </div>
              )}
              {!hideCloseBtn && (
                <div className={b('close-block')} onClick={handleClose}>
                  <CloseImg className={b('close-img')} />
                </div>
              )}
              {children}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )

  const node = document.getElementById('modal_root')
  if (node !== null) {
    return ReactDOM.createPortal(content, node)
  }
  return null
}

export default Modal
